import React from "react";
import Modal from '../ui/Modal';
import Button from '../ui/Button';
import { formatDateTime, formatDateTimeLocal } from '../../utils/dateUtils';
import { TASK_CATEGORIES } from '../../constants/status';

const TaskDetailsModal = ({
  isOpen,
  onClose,
  task,
  developers,
  projects,
}) => {
  if (!task) return null;

  const getDeveloperName = (developerId) => {
    const developer = developers.find((dev) => dev.id === developerId);
    if (developer) {
      return developer.name;
    }
    const developerByName = developers.find((dev) => dev.name === developerId);
    if (developerByName) {
      return developerByName.name;
    }
    return developerId || "Не назначен";
  };

  const getProjectName = (projectId) => {
    const project = projects.find((proj) => proj.id === projectId);
    if (project) {
      return project.name;
    }
    const projectByName = projects.find((proj) => proj.name === projectId);
    if (projectByName) {
      return projectByName.name;
    }
    return projectId || "Без проекта";
  };

  const getCategoryName = (category) => {
    const categoryMap = {
      [TASK_CATEGORIES.ITEMS1]: "В работе",
      [TASK_CATEGORIES.ITEMS2]: "В ожидании",
      [TASK_CATEGORIES.ITEMS3]: "Завершено",
    };
    return categoryMap[category] || category;
  };

  const getCategoryColor = (category) => {
    const colorMap = {
      [TASK_CATEGORIES.ITEMS1]: "bg-blue-100 text-blue-800",
      [TASK_CATEGORIES.ITEMS2]: "bg-yellow-100 text-yellow-800",
      [TASK_CATEGORIES.ITEMS3]: "bg-green-100 text-green-800",
    };
    return colorMap[category] || "bg-gray-100 text-gray-800";
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Детали задачи"
      size="large"
    >
      <div className="space-y-6">
        {/* Заголовок и статус */}
        <div className="flex justify-between items-start">
          <h2 className="text-2xl font-bold text-gray-900 pr-4">{task.title}</h2>
          <span className={`px-3 py-1 rounded-full text-sm font-medium ${getCategoryColor(task.category)}`}>
            {getCategoryName(task.category)}
          </span>
        </div>

        {/* Описание */}
        <div>
          <h3 className="text-lg font-semibold text-gray-800 mb-2">Описание</h3>
          <div className="bg-gray-50 rounded-lg p-4">
            <p className="text-gray-700 whitespace-pre-wrap leading-relaxed">
              {task.description || "Описание отсутствует"}
            </p>
          </div>
        </div>

        {/* Основная информация */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <h3 className="text-lg font-semibold text-gray-800 mb-3">Основная информация</h3>
            <div className="space-y-3">
              <div className="flex justify-between items-center py-2 border-b border-gray-200">
                <span className="font-medium text-gray-600">Разработчик:</span>
                <span className="text-gray-900">{getDeveloperName(task.developer)}</span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-200">
                <span className="font-medium text-gray-600">Проект:</span>
                <span className="text-gray-900">{getProjectName(task.project)}</span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-200">
                <span className="font-medium text-gray-600">Часы:</span>
                <span className="text-gray-900 font-semibold">{task.hours}</span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-gray-800 mb-3">Временные метки</h3>
            <div className="space-y-3">
              {task.createdAt && (
                <div className="flex justify-between items-center py-2 border-b border-gray-200">
                  <span className="font-medium text-gray-600">Создано:</span>
                                          <span className="text-gray-900 text-sm">{formatDateTimeLocal(task.createdAt)}</span>
                </div>
              )}
              {task.updatedAt && task.updatedAt !== task.createdAt && (
                <div className="flex justify-between items-center py-2 border-b border-gray-200">
                  <span className="font-medium text-gray-600">Обновлено:</span>
                                          <span className="text-gray-900 text-sm">{formatDateTimeLocal(task.updatedAt)}</span>
                </div>
              )}
              {task.editedAt && (
                <div className="flex justify-between items-center py-2 border-b border-gray-200">
                  <span className="font-medium text-gray-600">Отредактировано:</span>
                                          <span className="text-gray-900 text-sm">{formatDateTimeLocal(task.editedAt)}</span>
                </div>
              )}
              {task.completedAt && (
                <div className="flex justify-between items-center py-2 border-b border-gray-200">
                  <span className="font-medium text-gray-600">Завершено:</span>
                                          <span className="text-gray-900 text-sm">{formatDateTimeLocal(task.completedAt)}</span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Дополнительная информация */}
        {task.notes && (
          <div>
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Заметки</h3>
            <div className="bg-blue-50 rounded-lg p-4">
              <p className="text-gray-700 whitespace-pre-wrap leading-relaxed">
                {task.notes}
              </p>
            </div>
          </div>
        )}

        {/* Кнопки действий */}
        <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
          <Button onClick={onClose} variant="secondary">
            Закрыть
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default TaskDetailsModal; 